import type { ReactNode } from 'react';
import HelpLink from './Links/HelpLink';

interface TitleWithHelpLinkProps {
    label: string;
    link: string;
}

export default function TitleWithHelpLink({
    label,
    link,
}: TitleWithHelpLinkProps): ReactNode {
    return (
        <div className="flex align-items-center gap-2 justify-content-start">
            <h1>{label}</h1>
            <HelpLink href={link} />
        </div>
    );
}
